import type {RosterSidebarItem} from '../RosterSidebarLayout';
import type {RosterStatus} from '../RosterStatusBadge';

export interface BuildRosterSidebarItemParams {
  id: string;
  name: string | undefined;
  fallbackName: string;
  typeLabel: string | undefined;
  issues: number | undefined;
  issuesLabel: (count: number) => string;
  completeLabel: string;
  extractingLabel: string | undefined;
}

/** One sidebar card of a roster: name, type, missing-field status (hidden while `issues` is undefined) and an AI badge while the row's documents are read. */
export function buildRosterSidebarItem({
  id,
  name,
  fallbackName,
  typeLabel,
  issues,
  issuesLabel,
  completeLabel,
  extractingLabel
}: BuildRosterSidebarItemParams): RosterSidebarItem {
  const status: RosterStatus | undefined =
    issues === undefined
      ? undefined
      : issues > 0
        ? {tone: 'error', label: issuesLabel(issues)}
        : {tone: 'success', label: completeLabel};

  return {
    id,
    title: name?.trim() || fallbackName,
    subtitle: typeLabel,
    aiBadgeLabel: extractingLabel,
    status
  };
}
